<template>
    <div class="welcome-landing-root grade-10-page min-h-screen bg-background">
        <welcome-navbar />
        <grade-10-landing
            :courses-route="coursesRoute"
            :whatsapp-url="whatsappUrl"
            :start-route="startRoute"
        />
        <welcome-footer />
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed';
import WelcomeNavbar from '@/components/welcome/landing/WelcomeNavbar.vue';
import WelcomeFooter from '@/components/welcome/landing/WelcomeFooter.vue';
import Grade10Landing from '@/components/welcome/landing/grade10/Grade10Landing.vue';
import { gradeCoursesRoute, GRADE_PAGE_SLUGS } from '@/components/welcome/landing/landing-grade-data';
const GRADE_10_WHATSAPP_PHONE = '201234511022';
const GRADE_10_WHATSAPP_MESSAGE = 'السلام عليكم، أنا عايز أحجز كورس أولى ثانوي في البرمجة مع غنيم.';

export default {
    name: 'Grade10',
    components: {
        WelcomeNavbar,
        WelcomeFooter,
        Grade10Landing,
    },
    computed: {
        ...GlobalComputed,
        coursesRoute() {
            return gradeCoursesRoute(this.appData, GRADE_PAGE_SLUGS.GRADE_10);
        },
        startRoute() {
            return {
                name: 'register',
                query: {
                    grade_slug: GRADE_PAGE_SLUGS.GRADE_10,
                    grade_name: 'أولى ثانوي',
                },
            };
        },
        whatsappUrl() {
            return `https://wa.me/${GRADE_10_WHATSAPP_PHONE}?text=${encodeURIComponent(GRADE_10_WHATSAPP_MESSAGE)}`;
        },
    },
};
</script>

<style src="@/scss/welcome-landing.css"></style>
<style src="@/scss/grade-10-landing.css"></style>
